import util from '../util'

let controller = 'OperadorFrontEndBloqueioVinculo'
export default Object.assign({}, util.GetCrud(controller, ['getall']), {
	Desbloquear: function (dto) {
		return util.Axios.Patch(controller + `/Desbloquear`, dto)
	},
})
